import React from 'react';
import type { FC } from 'react';

import TicketListItem from './TicketListItem';
import type Ticket from './types/Ticket';
import { Heading, Skeleton } from '@chakra-ui/react';

interface TicketListProps {
  tickets: Ticket[];
  selectedTicket: string | null;
  isLoaded: boolean;
  fetchTickets: () => Promise<void>;
}

const TicketList: FC<TicketListProps> = (props) => {
  return (
    <div>
      <Heading>Omat palvelupyynnöt</Heading>
      {!props.isLoaded && <Skeleton height="74px" style={{ marginTop: '20px' }} isLoaded={props.isLoaded} />}
      {props.isLoaded && props.tickets.length === 0 && <div>Sinulla ei ole aiempia viestejä.</div>}
      {props.tickets.map((ticket) => {
        return (
          <TicketListItem
            fetchTickets={props.fetchTickets}
            ticket={ticket}
            selectedTicket={props.selectedTicket}
            key={ticket.id}
          />
        );
      })}
    </div>
  );
};

export default TicketList;
